import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import AboutUs from '@/pages/about-us/about-us'
import ChildrensOrtho from '@/pages/childrens-ortho/childrens-ortho'
import TeenOrtho from '@/pages/teen-ortho/teen-ortho'
import AdultsOrtho from '@/pages/adults-ortho/adults-ortho'
import WhyChooseUs from '@/pages/why-choose-us/why-choose-us'
import ContactUs from '@/pages/contact-us/contact-us'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility/accessibility'
import Styleguide from '@/pages/styleguide/styleguide'
import PageNotFound from '@/pages/404/404'
import scrollBehavior from '@/shared/functionality/scroll-behavior'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: true,
      component: Home,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-home.jpg'
    },
    {
      path: '/about-us',
      name: 'About Us',
      navigation: true,
      component: AboutUs,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-about.jpg'
    },
    {
      path: '/childrens-ortho',
      name: "Children's Orthodontics",
      navigation: true,
      component: ChildrensOrtho,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-children.jpg'
    },
    {
      path: '/teen-ortho',
      name: 'Teen Orthodontics',
      navigation: true,
      component: TeenOrtho,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-teens.jpg'
    },
    {
      path: '/adults-ortho',
      name: 'Adult Orthodontics',
      navigation: true,
      component: AdultsOrtho,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-adults.jpg'
    },
    {
      path: '/why-choose-us',
      name: 'Why Choose Us',
      navigation: true,
      component: WhyChooseUs,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-whychooseus.jpg'
    },
    {
      path: '/contact-us',
      name: 'Contact Us',
      navigation: true,
      component: ContactUs,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-contact.jpg'
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      navigation: false,
      component: ThankYou,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-about.jpg'
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility,
      image: 'http://d1xfe5t1xi02lg.cloudfront.net/menu-about.jpg'
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: '404',
      navigation: false,
      component: PageNotFound
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js